<template>
  <div class="jifen-container">
    <!-- 筛选区域 -->
    <el-card class="filter-card" shadow="never">
      <el-form :inline="true" :model="filterForm" class="filter-form">
        <el-form-item label="订单号">
          <el-input v-model="filterForm.keyword" placeholder="请输入订单号" clearable style="width: 200px;" />
        </el-form-item>
        <el-form-item label="订单状态">
          <el-select v-model="filterForm.status" placeholder="全部" clearable style="width: 140px;">
            <el-option label="待发货" value="待发货" />
            <el-option label="已处理" value="已处理" />
          </el-select>
        </el-form-item>
        <el-form-item label="下单时间">
          <el-date-picker
            v-model="dateRange"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            :clearable="true"
          />
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="handleSearch">查询</el-button>
          <el-button @click="handleReset">重置</el-button>
        </el-form-item>
      </el-form>
    </el-card>

    <!-- 表格 -->
    <el-card class="table-card" shadow="never">
      <el-table
        v-loading="loading"
        :data="orderList"
        height="56vh"
        border
        stripe
        style="width: 100%"
      >
        <el-table-column prop="id" label="ID" width="70" align="center" />
        <el-table-column prop="order_dh" label="订单号" min-width="200" show-overflow-tooltip />
        <el-table-column prop="crm_id" label="会员ID" width="90" align="center" />
        <el-table-column label="收货人" min-width="140">
          <template slot-scope="scope">
            <div>{{ scope.row.comlist_v2 }}</div>
            <div style="color: #999; font-size: 12px;">{{ scope.row.comlist_v3 }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="comlist_m1" label="收货地址" min-width="180" show-overflow-tooltip />
        <el-table-column label="商品明细" min-width="220">
          <template slot-scope="scope">
            <div v-for="(item, idx) in scope.row.goods_list" :key="idx" style="font-size: 12px;">
              {{ item.comlist_v1 }} x{{ item.comlist_s1 }}
            </div>
            <div v-if="!scope.row.goods_list || scope.row.goods_list.length === 0" style="color: #999;">—</div>
          </template>
        </el-table-column>
        <el-table-column label="消耗积分" width="110" align="center">
          <template slot-scope="scope">
            <span class="points">{{ scope.row.points_total }}</span>
          </template>
        </el-table-column>
        <el-table-column label="订单状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag size="small" :type="statusTagType(scope.row.status)">{{ scope.row.status }}</el-tag>
          </template>
        </el-table-column>
        <el-table-column prop="status_jie" label="接单状态" width="100" align="center" />
        <el-table-column label="操作" width="120" align="center" fixed="right">
          <template slot-scope="scope">
            <el-button
              v-if="scope.row.status === '待发货'"
              type="text"
              size="small"
              style="color: #f56c6c;"
              @click="handleCancel(scope.row)"
            >取消并退分</el-button>
            <span v-else style="color: #c0c4cc;">—</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination
        class="pagination"
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="currentPage"
        :page-sizes="[10, 20, 30, 50]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        background
      />
    </el-card>
  </div>
</template>

<script>
import { exchangeOrders, exchangeCancel } from '@/api/jifen'

export default {
  name: 'JifenExchangeOrders',
  data () {
    return {
      loading: false,
      orderList: [],
      total: 0,
      currentPage: 1,
      pageSize: 20,
      filterForm: {
        keyword: '',
        status: ''
      },
      dateRange: []
    }
  },
  mounted () {
    this.fetchList()
  },
  methods: {
    statusTagType (status) {
      const map = {
        待发货: 'warning',
        已处理: 'info'
      }
      return map[status] || 'info'
    },

    async fetchList () {
      this.loading = true
      try {
        const params = {
          page: this.currentPage,
          page_size: this.pageSize
        }
        if (this.filterForm.keyword) params.keyword = this.filterForm.keyword
        if (this.filterForm.status) params.status = this.filterForm.status
        if (this.dateRange && this.dateRange.length === 2) {
          params.start_date = this.dateRange[0]
          params.end_date = this.dateRange[1]
        }
        const res = await exchangeOrders(params)
        if (res && res.code === '0') {
          this.orderList = res.data || []
          this.total = res.total || 0
        } else {
          this.orderList = []
          this.total = 0
          this.$message.error(res && res.msg ? res.msg : '获取兑换订单失败')
        }
      } catch (error) {
        console.error('获取兑换订单失败', error)
        this.orderList = []
        this.total = 0
        this.$message.error('网络错误，请稍后重试')
      } finally {
        this.loading = false
      }
    },

    handleSearch () {
      this.currentPage = 1
      this.fetchList()
    },

    handleReset () {
      this.filterForm = { keyword: '', status: '' }
      this.dateRange = []
      this.currentPage = 1
      this.fetchList()
    },

    handleSizeChange (val) {
      this.pageSize = val
      this.currentPage = 1
      this.fetchList()
    },

    handleCurrentChange (val) {
      this.currentPage = val
      this.fetchList()
    },

    async handleCancel (row) {
      try {
        await this.$confirm(
          `确定要取消订单「${row.order_dh}」并退回 ${row.points_total} 积分吗？`,
          '提示',
          {
            confirmButtonText: '确定取消',
            cancelButtonText: '再想想',
            type: 'warning'
          }
        )
      } catch (e) {
        return
      }
      try {
        const res = await exchangeCancel({ id: row.id })
        if (res && res.code === '0') {
          this.$message.success(res.message || '取消成功，积分已退回')
          this.fetchList()
        } else {
          this.$message.error(res && res.msg ? res.msg : '取消失败')
        }
      } catch (error) {
        console.error('取消订单失败', error)
        this.$message.error(error.message || '网络错误')
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.jifen-container {
  padding: 20px;
  background-color: #f0f2f6;
  height: 85vh;
  box-sizing: border-box;
  overflow: auto;

  .filter-card {
    margin-bottom: 20px;

    .filter-form {
      margin-bottom: 0;
    }
  }

  .table-card {
    .pagination {
      margin-top: 20px;
      text-align: right;
    }
  }

  .points {
    color: #e6a23c;
    font-weight: bold;
  }
}
</style>
